<template>
  <div class="whxq">
    <div class="banner-wrap" style="backgroundImage: url(images/whxq/banner.jpg);"></div>
    <div class="con-wrap">
      <img src="images/whxq/1.jpg" alt="">
      <img src="images/whxq/2.jpg" alt="">
      <img src="images/whxq/3.jpg" alt="">
      <img src="images/whxq/4.jpg" alt="">
      <img src="images/whxq/5.jpg" alt="">
      <img src="images/whxq/6.jpg" alt="">
      <img src="images/whxq/7.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'whxq',
  data() {
    return {
      bannerimg: './images/whxq/banner.jpg'
    }
  }
}
</script>

<style lang="scss" scoped>
.whxq {
  padding-bottom: 80px;
}
.banner-wrap {
  width: 100%;
  height: 720px;
  // background-image: url(../../public/images/whxq/banner.jpg);
  background-size: cover;
}

.con-wrap {
  width: 80%;
  margin: auto;
  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>